import { render, staticRenderFns } from "./KlausA1.vue?vue&type=template&id=1f5dbe33&"
import script from "./KlausA1.vue?vue&type=script&lang=js&"
export * from "./KlausA1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports